import Legend from './Legend'

export default Legend



// WEBPACK FOOTER //
// ./src/legacy/containers/Graphs/components/Legend/index.js